import { cleanCloudinaryUrl, isCloudinaryURL, removeQueryString, } from '#pplx/frontend/common/files/urls.js';
import { uploadConnectorsAttachment } from '#pplx/frontend/components/hooks/attachments.js';
/**
 * Shared legacy/Composer connector flow. Consumers project the uploaded file into
 * their state and handle processing results using their existing UI policy.
 */
export async function uploadConnectorFile({ request, onUploaded, onProcessing, signal, }) {
    if (signal?.aborted)
        return { outcome: 'aborted' };
    let result;
    try {
        result = await uploadConnectorsAttachment(request);
    }
    catch {
        return { outcome: 'failure', errorCode: 'client_no_response' };
    }
    if (signal?.aborted)
        return { outcome: 'aborted' };
    const { response, errorCode } = result;
    const failureCode = errorCode === 'storage_upload_failed' ? 'storage_rejected' : errorCode;
    if (!response) {
        return { outcome: 'failure', errorCode: failureCode ?? 'client_no_response' };
    }
    if (response.rate_limited) {
        return { outcome: 'failure', errorCode: 'rate_limited' };
    }
    if (!response.success || !response.filename || !response.url) {
        return { outcome: 'failure', errorCode: failureCode ?? 'provider_download_failed' };
    }
    const status = isCloudinaryURL(response.url) ? 'success' : 'parsing';
    await onUploaded({
        filename: response.filename,
        originalUrl: response.url,
        url: status === 'success' ? cleanCloudinaryUrl(response.url) : removeQueryString(response.url),
        fileUUID: response.file_uuid ?? undefined,
        status,
    });
    if (signal?.aborted)
        return { outcome: 'aborted' };
    // Connector uploads have no skip-parsing option. Both consumers must observe
    // server processing, including security and moderation rejection.
    if (response.file_uuid && status === 'parsing') {
        await onProcessing(response.file_uuid, response.filename);
    }
    return { outcome: 'success', fileUUID: response.file_uuid ?? null };
}
//# sourceMappingURL=connectorAttachmentUpload.js.map